import React, { ReactNode } from "react"

import { FieldArrayFieldsProps, WrappedFieldArrayProps } from "redux-form/lib/FieldArray"
import { TitledLink } from "../../../types"
import FileDragAndDrop, { FileDragAndDropProps } from "../../../inputs/FileDragAndDrop"
import { toFileDragAndDropValue } from "./helpers"

type Props<T extends TitledLink> = {
  children: (name: string, field: T, index: number, fields: FieldArrayFieldsProps<T>) => ReactNode
  suffix?: ReactNode
  createNew?: (value: { url: string; name: string }) => T
  withoutDragAndDrop?: boolean
  dragAndDropProps?: Omit<FileDragAndDropProps, "value" | "onChange">
} & WrappedFieldArrayProps<T>

export const DocumentsContainer = <T extends TitledLink>({
  fields,
  suffix,
  children,
  createNew,
  withoutDragAndDrop,
  dragAndDropProps,
}: Props<T>) => {
  return (
    <>
      {Boolean(fields.length) && (
        <>
          <ul className="link-fields-container link-fields-container--documents">
            {fields.map((name, index) => {
              const { url } = fields.get(index)
              return (
                <li key={url} className="fade-in-down">
                  {children(name, fields.get(index), index, fields)}
                </li>
              )
            })}
          </ul>
          {suffix}
        </>
      )}
      {createNew && dragAndDropProps && !withoutDragAndDrop && (
        <FileDragAndDrop
          {...dragAndDropProps}
          value={toFileDragAndDropValue(fields)}
          onChange={(value: { fileList: { name: string; url: string }[] }) => {
            const links = value.fileList.map(createNew)
            links.forEach((link) => fields.push(link))
          }}
        />
      )}
    </>
  )
}
